module.exports = __webpack_public_path__ + "static/1_icon-91b08e5f676b0b5bd3b8708d335b3f31.svg";